import { buildDataTableCols, type DataTableCol } from '@/components/custom/erp/data-table-v2';
import { SearchColumnDef } from '@/components/custom/erp';
import { KhachHang } from '@/types/schemas';

export const MAIN_COLUMNS: DataTableCol<KhachHang>[] = [
  {
    field: 'customer_code',
    headerName: 'Mã khách hàng',
    width: 150,
    renderCell: params => params.row.customer_code || params.row.ma_kh || ''
  },
  {
    field: 'ten_kh',
    headerName: 'Tên khách hàng',
    width: 220,
    valueGetter: row => row.customer_name || ''
  },
  {
    field: 'ma_so_thue',
    headerName: 'Mã số thuế',
    width: 120,
    valueGetter: row => row.tax_code || ''
  },
  {
    field: 'dia_chi',
    headerName: 'Địa chỉ',
    width: 200,
    valueGetter: row => row.address || ''
  },
  {
    field: 'ma_nvbh',
    headerName: 'Mã nhân viên',
    width: 120,
    valueGetter: row => row.sales_rep_data?.ma_nhan_vien || ''
  },
  {
    field: 'cong_no_pthu',
    headerName: 'Công nợ p/thu',
    width: 150,
    columnType: 'number',
    align: 'right',
    headerAlign: 'center',
    valueGetter: row => row.receivable || 0
  },
  {
    field: 'nh_kh1',
    headerName: 'Nhóm 1',
    width: 120,
    valueGetter: row => row.customer_group1_data?.ma_nhom || ''
  },
  {
    field: 'nh_kh2',
    headerName: 'Nhóm 2',
    width: 120,
    valueGetter: row => row.customer_group2_data?.ma_nhom || ''
  },
  {
    field: 'nh_kh3',
    headerName: 'Nhóm 3',
    width: 120,
    valueGetter: row => row.customer_group3_data?.ma_nhom || ''
  },
  {
    field: 'dien_thoai',
    headerName: 'Điện thoại',
    width: 120,
    valueGetter: row => row.phone || ''
  },
  {
    field: 'e_mail',
    headerName: 'Thư',
    width: 120,
    valueGetter: row => row.email || ''
  }
];

export const exportMainColumns = (handleViewClick: (row: KhachHang) => void) => {
  const columns: DataTableCol<KhachHang>[] = MAIN_COLUMNS.map(col => {
    if (col.field !== 'ma_kh') {
      return col;
    }

    return {
      ...col,
      renderCell: params => (
        <button
          className='hover:text-blue-500 hover:underline'
          onClick={event => {
            event.stopPropagation();
            handleViewClick(params.row as KhachHang);
          }}
        >
          {String(params.value ?? '')}
        </button>
      )
    };
  });

  return buildDataTableCols(columns);
};

export const saleEmployeeColumns: SearchColumnDef[] = [
  {
    field: 'ma_nhan_vien',
    headerName: 'Mã nhân viên',
    width: 150,
    editable: true
  },
  {
    field: 'ho_ten_nhan_vien',
    headerName: 'Tên nhân viên',
    width: 220,
    editable: true
  }
];

export const paymentColumns: SearchColumnDef[] = [
  {
    field: 'ma_tt',
    headerName: 'Mã thanh toán',
    width: 150,
    editable: true
  },
  {
    field: 'ten_tt',
    headerName: 'Tên thanh toán',
    width: 220,
    editable: true
  },
  {
    field: 'han_tt',
    headerName: 'Hạn thanh toán',
    width: 150
  }
];

export const paymentMethodColumns: SearchColumnDef[] = [
  {
    field: 'ma_ph_thuc_hddt',
    headerName: 'Mã phương thức',
    width: 150,
    editable: true
  },
  {
    field: 'ten_pttt',
    headerName: 'Tên phương thức',
    width: 220,
    editable: true
  }
];

export const groupColumns: SearchColumnDef[] = [
  {
    field: 'ma_nhom',
    headerName: 'Mã nhóm',
    width: 150,
    editable: true
  },
  {
    field: 'ten_phan_nhom',
    headerName: 'Tên nhóm',
    width: 220,
    editable: true
  }
];

export const areaColumns: SearchColumnDef[] = [
  {
    field: 'rg_code',
    headerName: 'Mã khu vực',
    width: 150,
    editable: true
  },
  {
    field: 'rgname',
    headerName: 'Tên khu vực',
    width: 220,
    editable: true
  }
];

export const orderResourceColumns = (): SearchColumnDef[] => [
  {
    field: 'order_resource_code',
    headerName: 'Mã nguồn đơn',
    width: 150
  },
  {
    field: 'order_resource_name',
    headerName: 'Tên nguồn đơn',
    width: 220
  }
];
